// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import {
  getListCancellationReport,
  getListClientIncomeReport,
  getListDeliveryPickupReport,
  getListFinancialOrderReport,
  getListForemanTaskCompletionReport,
  getListGeographyRevenueReport,
  getListInventoryUsageReport,
  getListJobCostingReport,
  getListMarketingRevenueReport,
  getListOrderRevenueReport,
  getListOverbookingItemReport,
  getListQuoteRevenueReport,
  getListRevenueReport,
  getListSubRentalsReport,
  getListTaskCompletionReport,
} from './reportsThunk';

export interface IReportState {}

export const initialState: IReportState = {};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers(builder) {
    // GET: Get list overbooking item
    builder
      .addCase(getListOverbookingItemReport.pending, (_state) => {})
      .addCase(getListOverbookingItemReport.fulfilled, (_state) => {})
      .addCase(getListOverbookingItemReport.rejected, (_state) => {});

    // GET: Get list sub rentals
    builder
      .addCase(getListSubRentalsReport.pending, (_state) => {})
      .addCase(getListSubRentalsReport.fulfilled, (_state) => {})
      .addCase(getListSubRentalsReport.rejected, (_state) => {});

    // GET: Get list client income
    builder
      .addCase(getListClientIncomeReport.pending, (_state) => {})
      .addCase(getListClientIncomeReport.fulfilled, (_state) => {})
      .addCase(getListClientIncomeReport.rejected, (_state) => {});

    // GET: Get list revenue report
    builder
      .addCase(getListRevenueReport.pending, (_state) => {})
      .addCase(getListRevenueReport.fulfilled, (_state) => {})
      .addCase(getListRevenueReport.rejected, (_state) => {});

    // GET: Get list geography revenue report
    builder
      .addCase(getListGeographyRevenueReport.pending, (_state) => {})
      .addCase(getListGeographyRevenueReport.fulfilled, (_state) => {})
      .addCase(getListGeographyRevenueReport.rejected, (_state) => {});

    // GET: Get list quote revenue report
    builder
      .addCase(getListQuoteRevenueReport.pending, (_state) => {})
      .addCase(getListQuoteRevenueReport.fulfilled, (_state) => {})
      .addCase(getListQuoteRevenueReport.rejected, (_state) => {});

    // GET: Get list order revenue report
    builder
      .addCase(getListOrderRevenueReport.pending, (_state) => {})
      .addCase(getListOrderRevenueReport.fulfilled, (_state) => {})
      .addCase(getListOrderRevenueReport.rejected, (_state) => {});

    // GET: Get list cancellation report
    builder
      .addCase(getListCancellationReport.pending, (_state) => {})
      .addCase(getListCancellationReport.fulfilled, (_state) => {})
      .addCase(getListCancellationReport.rejected, (_state) => {});

    // GET: Get list delivery pickup report
    builder
      .addCase(getListDeliveryPickupReport.pending, (_state) => {})
      .addCase(getListDeliveryPickupReport.fulfilled, (_state) => {})
      .addCase(getListDeliveryPickupReport.rejected, (_state) => {});

    // GET: Get list task completion report
    builder
      .addCase(getListTaskCompletionReport.pending, (_state) => {})
      .addCase(getListTaskCompletionReport.fulfilled, (_state) => {})
      .addCase(getListTaskCompletionReport.rejected, (_state) => {});

    // GET: Get list job costing report
    builder
      .addCase(getListJobCostingReport.pending, (_state) => {})
      .addCase(getListJobCostingReport.fulfilled, (_state) => {})
      .addCase(getListJobCostingReport.rejected, (_state) => {});

    // GET: Get list inventory usage report
    builder
      .addCase(getListInventoryUsageReport.pending, (_state) => {})
      .addCase(getListInventoryUsageReport.fulfilled, (_state) => {})
      .addCase(getListInventoryUsageReport.rejected, (_state) => {});

    // GET: Get list foreman task completion report
    builder
      .addCase(getListForemanTaskCompletionReport.pending, (_state) => {})
      .addCase(getListForemanTaskCompletionReport.fulfilled, (_state) => {})
      .addCase(getListForemanTaskCompletionReport.rejected, (_state) => {});

    // GET: Get list marketing revenue report
    builder
      .addCase(getListMarketingRevenueReport.pending, (_state) => {})
      .addCase(getListMarketingRevenueReport.fulfilled, (_state) => {})
      .addCase(getListMarketingRevenueReport.rejected, (_state) => {});

    // GET: Get list financial order report
    builder
      .addCase(getListFinancialOrderReport.pending, (_state) => {})
      .addCase(getListFinancialOrderReport.fulfilled, (_state) => {})
      .addCase(getListFinancialOrderReport.rejected, (_state) => {});
  },
});

// Action
export const reportsActions = reportsSlice.actions;

// Selectors
// Reducer
const reportsReducer = reportsSlice.reducer;
export default reportsReducer;
